import Conclusionllustration from '@/assets/illustration/new_site_conclusion.svg'

export default {
  title: 'Criar Novo Site Wordpress',
  loginInformation: 'Informações de login do Wordpress',
  createNewSite: 'Criar Novo Site',
  fields: {
    domain: {
      create: {
        label: 'Quero criar um novo site',
        description: 'Quero criar um site do zero na hospedagem Wordpress Locaweb'
      },
      transfer: {
        label: 'Quero transferir um site',
        description: 'Tenho um site Wordpress em outro provedor e quero transferi-lo para a Locaweb'
      }
    },
    domainField: {
      label: 'Qual domínio você usará neste site?',
      placeholder: 'Digite seu domínio'
    },
    domainHint: {
      title: 'Domínio',
      subtitle: `O domínio é um endereço utilizado para que as pessoas encontrem seu site na internet.
          Caso você ainda não tenha um domínio registrado, poderá
          <a href="https://www.locaweb.com.br/registro-de-dominio/" style="text-decoration:none" target="_blank" class="primary--text">registrar um no nosso site.</a>
          Caso queira utilizar um domínio registrado em outra provedora será necessário configurá-lo para nossa hospedagem.
          <a href="https://ajuda.locaweb.com.br/wiki/como-usar-um-dominio-que-esta-em-outro-provedor-hospedagem-wordpress-locaweb/" style="text-decoration:none" target="_blank" class="primary--text">Veja como neste artigo.</a>`
    },
    title: {
      label: 'Título do site',
      hint: 'Este será o nome do seu site dentro do Wordpress'
    },
    email: {
      label: 'E-mail'
    },
    user: {
      label: 'Usuário',
      hint: 'Este será seu nome de usuário no Wordpress'
    },
    password: {
      label: 'Senha',
      hint: 'Senha para acessar este site no Wordpress'
    }
  },
  validations: {
    domain: {
      regex: 'Preencha um domínio válido. Ex: dominio.com.br ou dominio.net'
    }
  },
  conclusion: {
    default: {
      title: 'A instalação será concluída em instantes',
      text: 'O seu site estará pronto em alguns minutos. Você pode voltar para a lista de sites para verificar o status da instalação.',
      illustration: Conclusionllustration
    },
    actions: [
      { title: 'Voltar para a lista de sites' }
    ]
  }
}
